// Carrossel simples de coleções: setas prev/next fazem scroll do
// track por "uma página" de largura visível (scroll-snap nativo cuida
// do alinhamento dos slides). Sem dependências externas.
class CollectionCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-carousel-track]');
    this.prevBtn = this.querySelector('[data-carousel-prev]');
    this.nextBtn = this.querySelector('[data-carousel-next]');
    if (!this.track) return;

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.#scrollByPage(-1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.#scrollByPage(1));
    }

    this.#updateArrows();
    this.track.addEventListener('scroll', () => this.#updateArrows(), { passive: true });
    window.addEventListener('resize', () => this.#updateArrows());
  }

  #scrollByPage(direction) {
    const amount = this.track.clientWidth * 0.9 * direction;
    this.track.scrollBy({ left: amount, behavior: 'smooth' });
  }

  #updateArrows() {
    if (!this.prevBtn && !this.nextBtn) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const atStart = this.track.scrollLeft <= 1;
    const atEnd = this.track.scrollLeft >= maxScroll - 1;

    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = maxScroll <= 1 || atEnd;

    if (this.prevBtn) this.prevBtn.style.opacity = atStart ? '0.3' : '1';
    if (this.nextBtn) this.nextBtn.style.opacity = maxScroll <= 1 || atEnd ? '0.3' : '1';
  }
}

if (!customElements.get('collection-carousel')) {
  customElements.define('collection-carousel', CollectionCarousel);
}
